<template>
    <div id="contentcontainter" class="standard-mode">
        <!-- <a class="sr-only sr-only-focusable" href="#homeMain">Skip to main content</a> -->

        <v-dialog v-model="videodialog" max-width="800px" role="dialog" aria-modal="true" aria-labelledby="tutorial-video-title">
            <v-card v-focus-trap="videodialog">
                <v-card-title>
                    <h2 id="tutorial-video-title" class="sr-only">{{ videoDialogTitle }}</h2>
                    <v-btn class="mt-2" @click="videodialog = false" right absolute icon :aria-label="'Close dialog'">
                        <v-icon aria-hidden="true">mdi-close</v-icon>
                    </v-btn>
                </v-card-title>

                <v-card-text class="mt-4">
                    <div class="video-container">
                        <iframe
                            data-focus-first
                            tabindex="0"
                            style="border-radius: 10px"
                            width="560"
                            height="315"
                            :src="videoUrl"
                            :title="videoDialogTitle"
                            frameborder="0"
                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                            allowfullscreen></iframe>
                    </div>
                </v-card-text>

                <v-card-actions class="d-flex">
                    <v-btn class="ml-auto mb-2 mr-2" rounded color="primary" @click="videodialog = false"> close </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <div id="homeMain" role="main" aria-label="Homepage suites overview" style="max-width: 1800px; margin: auto">
            <!-- OBI stays unchanged -->
            <template v-if="isOBI">
                <v-row class="mt-5" no-gutters style="display: inline-flex">
                    <v-card max-width="450px" class="mr-10 rounded_card quaroshadow transparent topboarder" aria-label="Welcome banner">
                        <v-card-text style="padding-top: 5px; padding-bottom: 5px">
                            <v-row>
                                <v-col>
                                    <h1 class="my-2" style="font-family: 'CalSans', sans-serif">
                                        {{ titleUsername }}
                                    </h1>

                                    <p class="mb-3 mt-2" style="font-size: 16px; font-family: 'CalSans', sans-serif">
                                        {{ bannertext.firstp }}
                                    </p>

                                    <div v-if="isOBI">
                                        <p style="background-color: #eeeeee; padding: 10px; border-radius: 15px">
                                            In our new version of Apollon you will find the Google Keyword Planner in the Research Suite. You can go directly to
                                            <a href="https://apollon.obi.com/searchvolume"> Google Search Volume </a>
                                            to get the search volume of a list of keywords. Or you can use
                                            <a href="https://apollon.obi.com/ideas">Ideas</a>
                                            to get new keyword ideas.
                                        </p>

                                        <p style="background-color: #eeeeee; padding: 10px; border-radius: 15px">
                                            In the Monitoring Suite you will find OBI
                                            <a href="https://apollon.obi.com/monitoring"> Visibility in Google for different keyword sets </a>. At the moment we provide the visibility of our online
                                            shop with the E-Com Index Germany. More indexes will follow!
                                        </p>

                                        <p style="background-color: #eeeeee; padding: 10px; border-radius: 15px">
                                            If you have any questions, please contact our Google support chat.
                                            <v-btn
                                                class="ml-2"
                                                x-small
                                                rounded
                                                color="primary"
                                                @click="openlink('https://chat.google.com/room/AAAAu4yTgFI?cls=7')"
                                                aria-label="Open Google support chat">
                                                <v-icon size="14px" class="mr-1" aria-hidden="true"> mdi-message </v-icon>
                                                Chat
                                            </v-btn>
                                        </p>
                                    </div>
                                </v-col>
                            </v-row>
                        </v-card-text>
                    </v-card>

                    <v-card v-if="isOBI" max-width="450px" class="mr-auto rounded_card quaroshadow transparent topboarder" aria-label="Apollon onboarding information">
                        <v-card-text style="padding-top: 5px; padding-bottom: 5px">
                            <v-row>
                                <v-col>
                                    <div>
                                        <h1 class="my-2 mb-3" style="font-family: 'CalSans', sans-serif">New to Apollon?</h1>

                                        <p style="background-color: #eeeeee; padding: 10px; border-radius: 15px">
                                            You can now access our general onboarding slides here. These explain the basic functions of the Keyword Ideas, Google Search Volume and Monitoring Suite
                                            modules.
                                        </p>

                                        <div class="d-flex">
                                            <img
                                                @click="openlink('https://go.obi.de/apollon-training-slides')"
                                                class="obislidesimg"
                                                height="200px"
                                                width="auto"
                                                src="../assets/obi_slides.png"
                                                alt="Cover image for Apollon training slides" />
                                        </div>
                                    </div>
                                </v-col>
                            </v-row>
                        </v-card-text>
                    </v-card>
                </v-row>
            </template>

            <!-- NON OBI -->
            <template v-else>
                <!-- Quaro Home v2 (every non-OBI customer) -->
                <template v-if="showNewDashboard">
                    <div class="qhome-v2">
                        <!-- Greeting -->
                        <div class="qh-greet">
                            <h1>{{ greeting.title }}</h1>
                            <p>{{ greeting.subtitle }}</p>
                        </div>
                        <!-- Top row: dark suite deck, full width -->
                        <div class="qh-toprow">
                            <div class="qh-zone">
                                <div class="qh-hero qh-deck">
                                    <div class="qh-deck-head">
                                        <button v-if="askAiAvailable" class="qh-ctab" :class="{ on: activeDeckTab === 'ask' }" type="button" @click="deckTab = 'ask'">
                                            <v-icon size="14" color="#1cedb3" aria-hidden="true">mdi-creation</v-icon>
                                            Ask AI
                                        </button>
                                        <button v-for="s in deckSuites" :key="s.key" class="qh-ctab" :class="{ on: activeDeckTab === s.key }" type="button" @click="deckTab = s.key">
                                            {{ s.tab }}
                                        </button>
                                    </div>

                                    <div class="qh-deck-body">
                                        <!-- Ask AI tab: hands the question over to the SEO AI page (/seo-ai) -->
                                        <template v-if="activeDeckTab === 'ask'">
                                            <div class="qh-deck-left">
                                                <span class="qh-eyebrow">
                                                    <v-icon size="14" color="#1cedb3" aria-hidden="true">mdi-creation</v-icon>
                                                    Quaro SEO AI
                                                </span>
                                                <h2>Ask the SEO AI</h2>
                                                <p class="qh-sub">Ask anything about keywords, rankings or any other SEO task. The AI is connected to relevant data sources.</p>
                                                <div class="qh-field">
                                                    <v-icon size="20" color="primary" class="qh-spark" aria-hidden="true">mdi-creation</v-icon>
                                                    <input v-model="composerValue" type="text" placeholder="What would you like to find out?" @keydown.enter.prevent="submitComposer" />
                                                    <button type="button" class="qh-send" :disabled="!composerValue.trim()" @click="submitComposer">
                                                        Send
                                                        <v-icon size="18" color="white" aria-hidden="true">mdi-send</v-icon>
                                                    </button>
                                                </div>
                                                <div class="qh-chips">
                                                    <button v-for="(p, i) in composerPrompts" :key="i" class="qh-chip" type="button" @click="composerValue = p">
                                                        <v-icon size="14" color="#1cedb3" aria-hidden="true">mdi-creation</v-icon>
                                                        {{ p }}
                                                    </button>
                                                </div>
                                            </div>
                                        </template>

                                        <!-- Suite tab -->
                                        <template v-else>
                                            <div class="qh-deck-2col">
                                                <div class="qh-deck-left">
                                                    <h2 :key="activeDeckSuite.key">{{ activeDeckSuite.title }}</h2>
                                                    <p class="qh-sub">{{ activeDeckSuite.desc }}</p>
                                                    <button type="button" class="qh-suite-btn" :disabled="activeDeckSuite.disabled" @click="goToActiveDeckSuite">
                                                        {{ activeDeckSuite.btn }}
                                                    </button>
                                                    <p v-if="activeDeckSuite.disabled" class="qh-disabled-note">This suite is currently not active for your plan.</p>
                                                </div>
                                                <div class="qh-deck-right">
                                                    <div class="qh-gpanel">
                                                        <div class="qh-gfx" v-html="deckGraphic(activeDeckSuite.key)"></div>
                                                    </div>
                                                </div>
                                            </div>
                                        </template>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <!-- Help cards -->
                        <div class="qh-help">
                            <div class="qh-hcard">
                                <div class="qh-top">
                                    <span class="qh-ic"><v-icon size="22" color="primary" aria-hidden="true">mdi-play-circle-outline</v-icon></span>
                                    <div>
                                        <h3>Watch Quick Start Video</h3>
                                        <p>Get a quick overview of Quaro's main features and workflows.</p>
                                    </div>
                                </div>
                                <button class="qh-act" type="button" @click="openTutorial(videoUrls[1])">Start Tutorial</button>
                            </div>

                            <div class="qh-hcard">
                                <div class="qh-top">
                                    <span class="qh-ic"><v-icon size="22" color="primary" aria-hidden="true">mdi-book-open-page-variant-outline</v-icon></span>
                                    <div>
                                        <h3>Explore Tutorials &amp; Guides</h3>
                                        <p>Use the knowledge base to learn workflows and find step-by-step onboarding material.</p>
                                    </div>
                                </div>
                                <button class="qh-act" type="button" @click="goToTutorialCenter">Open Knowledge Base</button>
                            </div>

                            <div class="qh-hcard">
                                <div class="qh-top">
                                    <span class="qh-ic"><v-icon size="22" color="primary" aria-hidden="true">mdi-calendar-check-outline</v-icon></span>
                                    <div>
                                        <h3>Book a Demo</h3>
                                        <p>Schedule a live walkthrough with our team and get onboarding support for your setup.</p>
                                    </div>
                                </div>
                                <button class="qh-act" type="button" @click="openDemoBooking">Book a Demo</button>
                            </div>
                        </div>

                        <!-- Explore capabilities -->
                        <div class="qh-explore-head">
                            <h2>Explore Quaro's capabilities</h2>
                            <p>The suites stay visible but secondary until you've generated first results.</p>
                        </div>
                        <div class="qh-suites">
                            <div class="qh-scard">
                                <div class="qh-lab">Research Suite</div>
                                <h3>Research Keywords</h3>
                                <p>Understand what people search for and find opportunities fast.</p>
                                <button class="qh-act" type="button" @click="$router.push('/ideas')">Get Started</button>
                            </div>

                            <div v-if="showLegacyExtraSuites" class="qh-scard">
                                <div class="qh-lab">Content Suite</div>
                                <h3>Create Content</h3>
                                <p>Create content briefings and move from topic to output.</p>
                                <button class="qh-act" type="button" @click="$router.push('/content-project/setup')">Get Started</button>
                            </div>

                            <div v-if="showLegacyExtraSuites" class="qh-scard">
                                <div class="qh-lab">Monitoring Suite</div>
                                <h3>Rank Tracking</h3>
                                <p>Track your rankings in search once your first keyword set is ready.</p>
                                <button class="qh-act" type="button" @click="$router.push('/monitoring/setup')">Get Started</button>
                            </div>

                            <div v-if="showLegacyExtraSuites" class="qh-scard">
                                <div class="qh-lab">AI Suite</div>
                                <h3>{{ aiText.title }}</h3>
                                <p>Monitor AI prompts and responses in one place.</p>
                                <button class="qh-act" type="button" @click="$router.push('/ai-suite')">Get Started</button>
                            </div>
                        </div>
                    </div>
                </template>

            </template>
        </div>
    </div>
</template>

<script>
    import { onboardingSuiteGraphics } from "../assets/onboarding-suite-graphics"

    export default {
        name: "Home",
        components: {},
        data() {
            return {
                aiText: {
                    title: "AI Visibility Tracking",
                    subtitle: "AI Suite",
                    firstp: "Create, upload and monitor AI prompts and responses in one place."
                },
                videodialog: false,
                videoUrl: "https://www.youtube.com/embed/6J1xuj3LqPs",
                videoUrls: ["https://www.youtube.com/embed/6J1xuj3LqPs", "https://www.youtube.com/embed/JIwOqGzpBRU"],
                bannertext: {
                    title: "Hi",
                    firstp: "welcome back! What do you want to do today?"
                },
                onboardingCompletedSteps: [],
                activeOnboardingSuiteKey: "ai",
                onboardingSuiteRotationTimer: null,
                // Quaro Home v2 — composer / deck state
                deckTab: null, // null = Ask AI while the chat is available, otherwise the first suite
                composerValue: "",
                // Same examples as on the SEO AI page (SEOKI.vue, prompt_examples)
                composerPrompts: ["What seo tasks can you do?", "Do a keyword research for the topic X", "How can I improve my website's SEO?", "Do an on-page SEO audit for my site"]
            }
        },
        created() {
            this.loadOnboardingCompletedSteps()
        },
        mounted() {
            this.startOnboardingSuiteRotation()
        },
        beforeDestroy() {
            this.stopOnboardingSuiteRotation()
        },
        computed: {
            videoDialogTitle() {
                if (this.videoUrl === this.videoUrls[0]) return "Tutorial video Content Suite"
                if (this.videoUrl === this.videoUrls[1]) return "Tutorial video Research Suite"
                return "Tutorial video"
            },
            firstName() {
                try {
                    const encryptedUsername = localStorage.getItem("username")
                    if (!encryptedUsername) return ""

                    const decrypted = this.CryptoJS.AES.decrypt(encryptedUsername, process.env.VUE_APP_ENCRYPTION_PW).toString(this.CryptoJS.enc.Utf8)

                    return decrypted ? decrypted.split(" ")[0] : ""
                } catch (error) {
                    return ""
                }
            },
            isAIDisabled() {
                const status = this.$store?.state?.company_status_ai_suite
                if (!status) return false
                return !(status === "active" || status === "testing")
            },
            isOBI() {
                return window.location.href.includes("apollon.obi.com")
            },
            isMonitoringDisabled() {
                return this.$store.state.company_status_monitoring_suite != "active" && this.$store.state.company_status_monitoring_suite != "testing"
            },
            isResearchDisabled() {
                return this.$store.state.company_status != "active" && this.$store.state.company_status != "testing" && this.$store.state.company_status != "free"
            },
            isContentDisabled() {
                return this.$store.state.company_status_content_suite != "active" && this.$store.state.company_status_content_suite != "testing"
            },
            titleUsername() {
                return this.firstName ? this.bannertext.title + " " + this.firstName + "," : this.bannertext.title + ","
            },
            company_id() {
                try {
                    if (!localStorage.company_id) return ""
                    return this.CryptoJS.AES.decrypt(localStorage.company_id, process.env.VUE_APP_ENCRYPTION_PW).toString(this.CryptoJS.enc.Utf8)
                } catch (error) {
                    return ""
                }
            },
            showLegacyExtraSuites() {
                return this.company_id !== "1710"
            },
            isInTrial() {
                // "free" is a plan of its own, not a trial - only a "testing" status counts here.
                const state = this.$store.state
                return state.company_status === "testing" || state.company_status_content_suite === "testing" || state.company_status_monitoring_suite === "testing" || state.company_status_ai_suite === "testing"
            },
            hasResearchData() {
                return this.suiteDataExists(["research_projects", "researchProjects", "keyword_ideas_projects", "ideas_projects", "projects", "research_count", "researchProjectsCount"])
            },
            hasContentData() {
                return this.suiteDataExists(["content_projects", "contentProjects", "briefings", "content_briefings", "content_count", "contentProjectsCount"])
            },
            hasMonitoringData() {
                return this.suiteDataExists(["monitoring_projects", "monitoringProjects", "rank_trackings", "rankTrackingProjects", "monitoring_count", "monitoringProjectsCount"])
            },
            hasAIData() {
                return this.suiteDataExists(["ai_projects", "aiProjects", "prompt_sets", "ai_prompt_sets", "ai_count", "aiProjectsCount"])
            },
            hasAnySuiteData() {
                return this.hasResearchData || this.hasContentData || this.hasMonitoringData || this.hasAIData
            },
            showNewDashboard() {
                // Home v2 is for every customer; only OBI keeps its own block above.
                return !this.isOBI
            },
            onboardingSuiteCards() {
                return [
                    {
                        key: "research",
                        tabLabel: "Research",
                        title: "Find keyword opportunities",
                        desc: "Identify what your audience is searching for and discover the easiest entry opportunities.",
                        button: "Start Keyword Research",
                        image: require("../assets/undraw_searching.svg"),
                        visualLabel: "Research Suite",
                        visualAlt: "Illustration for research suite",
                        visualSubtitle: "Keyword Discovery",
                        disabled: this.isResearchDisabled
                    },
                    {
                        key: "content",
                        tabLabel: "Content",
                        title: "Create your first content briefing",
                        desc: "Turn your keyword insights into structured briefs and move faster from topic to draft.",
                        button: "Create Briefing",
                        image: require("../assets/undraw_typewriter.svg"),
                        visualLabel: "Content Suite",
                        visualAlt: "Illustration for content suite",
                        visualSubtitle: "Briefings & Workflows",
                        disabled: this.isContentDisabled
                    },
                    {
                        key: "monitoring",
                        tabLabel: "Monitoring",
                        title: "Track rankings and visibility",
                        desc: "Set up your first tracking project and monitor how your keywords perform over time.",
                        button: "Setup Monitoring",
                        image: require("../assets/undraw_setup_analytics.svg"),
                        visualLabel: "Monitoring Suite",
                        visualAlt: "Illustration for monitoring suite",
                        visualSubtitle: "Rank Tracking",
                        disabled: this.isMonitoringDisabled
                    },
                    {
                        key: "ai",
                        tabLabel: "AI Tracking",
                        title: "Explore AI visibility tracking",
                        desc: "Monitor prompts and responses in AI systems and understand your visibility beyond classic search.",
                        button: "Open AI Suite",
                        image: require("../assets/undraw_large-language-models_m4no.svg"),
                        visualLabel: "AI Suite",
                        visualAlt: "Illustration for AI suite",
                        visualSubtitle: "Prompt Visibility",
                        disabled: this.isAIDisabled
                    }
                ]
            },
            activeOnboardingSuiteCard() {
                return this.onboardingSuiteCards.find((suiteCard) => suiteCard.key === this.activeOnboardingSuiteKey) || this.onboardingSuiteCards[0]
            },
            activeOnboardingSuiteGraphic() {
                return onboardingSuiteGraphics[this.activeOnboardingSuiteCard.key] || ""
            },
            onboardingSteps() {
                const steps = [
                    {
                        key: "research",
                        title: "Find keyword opportunities",
                        desc: "Start with research to discover what your audience is searching for.",
                        button: "Start",
                        done: this.hasResearchData || this.isOnboardingStepCompleted("research")
                    }
                ]

                if (this.showLegacyExtraSuites) {
                    steps.push(
                        {
                            key: "content",
                            title: "Create a content briefing",
                            desc: "Turn your first research into a structured briefing.",
                            button: "Create",
                            done: this.hasContentData || this.isOnboardingStepCompleted("content")
                        },
                        {
                            key: "monitoring",
                            title: "Track your rankings",
                            desc: "Set up monitoring once you have your first keyword set.",
                            button: "Setup",
                            done: this.hasMonitoringData || this.isOnboardingStepCompleted("monitoring")
                        },
                        {
                            key: "ai",
                            title: "Explore AI Visibility Tracking",
                            desc: "Use AI Suite once you are ready for advanced monitoring.",
                            button: "Open",
                            done: this.hasAIData || this.isOnboardingStepCompleted("ai")
                        }
                    )
                }

                return steps
            },
            onboardingProgress() {
                return this.onboardingSteps.filter((step) => step.done).length
            },
            greeting() {
                const name = this.firstName
                if (this.isInTrial) {
                    return { title: name ? "Welcome to Quaro, " + name + "! 👋" : "Welcome to Quaro! 👋", subtitle: "Let's see how we can help you get started." }
                }
                return { title: name ? "Hi " + name + ", welcome back! 👋" : "Hi, welcome back! 👋", subtitle: "What do you want to do today?" }
            },
            deckSuites() {
                return [
                    {
                        key: "research",
                        tab: "Research",
                        title: "Find keyword opportunities",
                        desc: "Identify what your audience is searching for and discover the easiest entry opportunities.",
                        btn: "Start keyword research",
                        disabled: this.isResearchDisabled
                    },
                    {
                        key: "content",
                        tab: "Content",
                        title: "Create a content briefing",
                        desc: "Turn your keyword insights into structured briefs and move faster from topic to draft.",
                        btn: "Create briefing",
                        disabled: this.isContentDisabled
                    },
                    {
                        key: "monitoring",
                        tab: "Monitoring",
                        title: "Track rankings and visibility",
                        desc: "Set up your first tracking project and monitor how your keywords perform over time.",
                        btn: "Setup monitoring",
                        disabled: this.isMonitoringDisabled
                    },
                    {
                        key: "ai",
                        tab: "AI",
                        title: "Explore AI visibility tracking",
                        desc: "Monitor prompts and responses in AI systems and understand your visibility beyond classic search.",
                        btn: "Open AI Suite",
                        disabled: this.isAIDisabled
                    }
                ]
            },
            askAiAvailable() {
                // Same rule as the SEO AI nav entry (App.vue showAiChatNav) and the /seo-ai route guard.
                const state = this.$store.state
                const status = state.company_status_ki_chat
                return !!(state.ki_chat || state.admin) && (status === "active" || status === "testing" || status === "free")
            },
            activeDeckTab() {
                if (this.deckTab && (this.deckTab !== "ask" || this.askAiAvailable)) return this.deckTab
                return this.askAiAvailable ? "ask" : this.deckSuites[0].key
            },
            activeDeckSuite() {
                return this.deckSuites.find((s) => s.key === this.activeDeckTab) || this.deckSuites[0]
            }
        },
        watch: {
            hasResearchData(value) {
                if (value) this.markOnboardingStepCompleted("research")
            },
            hasContentData(value) {
                if (value) this.markOnboardingStepCompleted("content")
            },
            hasMonitoringData(value) {
                if (value) this.markOnboardingStepCompleted("monitoring")
            },
            hasAIData(value) {
                if (value) this.markOnboardingStepCompleted("ai")
            }
        },
        methods: {
            submitComposer() {
                const text = (this.composerValue || "").trim()
                if (!text || !this.askAiAvailable) return
                // Hand-over via the store (not ?q=: the router-view is keyed by fullPath and would remount the
                // page). SEOKI.vue picks the question up in consumeHomeQuestion and sends it.
                this.$store.commit("SET_KI_CHAT_PENDING_QUESTION", text)
                this.composerValue = ""
                this.$router.push("/seo-ai").catch(() => {})
            },
            goToActiveDeckSuite() {
                if (!this.activeDeckSuite || this.activeDeckSuite.disabled) return
                this.handleOnboardingAction(this.activeDeckSuite.key)
            },
            deckGraphic(key) {
                return onboardingSuiteGraphics[key] || ""
            },
            onboardingStorageKey() {
                return `quaro_onboarding_completed_steps_${this.company_id || "global"}`
            },
            loadOnboardingCompletedSteps() {
                try {
                    const raw = localStorage.getItem(this.onboardingStorageKey())
                    if (!raw) {
                        this.onboardingCompletedSteps = []
                        return
                    }

                    const parsed = JSON.parse(raw)
                    this.onboardingCompletedSteps = Array.isArray(parsed) ? parsed : []
                } catch (error) {
                    this.onboardingCompletedSteps = []
                }
            },
            saveOnboardingCompletedSteps() {
                try {
                    localStorage.setItem(this.onboardingStorageKey(), JSON.stringify(this.onboardingCompletedSteps))
                } catch (error) {
                    // Ignore storage errors and keep UI functional.
                }
            },
            isOnboardingStepCompleted(key) {
                return this.onboardingCompletedSteps.includes(key)
            },
            markOnboardingStepCompleted(key) {
                if (!key || this.onboardingCompletedSteps.includes(key)) return

                this.onboardingCompletedSteps = [...this.onboardingCompletedSteps, key]
                this.saveOnboardingCompletedSteps()
            },
            startOnboardingSuiteRotation() {
                this.stopOnboardingSuiteRotation()

                if (!this.showNewDashboard) return
                if (this.onboardingSuiteCards.length < 2) return

                this.onboardingSuiteRotationTimer = window.setInterval(() => {
                    const cards = this.onboardingSuiteCards
                    if (!cards.length) return

                    const currentIndex = cards.findIndex((suiteCard) => suiteCard.key === this.activeOnboardingSuiteKey)
                    const safeIndex = currentIndex >= 0 ? currentIndex : 0
                    const nextIndex = (safeIndex + 1) % cards.length

                    this.activeOnboardingSuiteKey = cards[nextIndex].key
                }, 5000)
            },
            stopOnboardingSuiteRotation() {
                if (!this.onboardingSuiteRotationTimer) return

                clearInterval(this.onboardingSuiteRotationTimer)
                this.onboardingSuiteRotationTimer = null
            },
            goToActiveOnboardingSuite() {
                if (!this.activeOnboardingSuiteCard || this.activeOnboardingSuiteCard.disabled) return
                this.handleOnboardingAction(this.activeOnboardingSuiteCard.key)
            },
            openlink(link) {
                window.open(link, "_blank")
            },
            openTutorial(url) {
                this.videoUrl = url
                this.videodialog = true
            },
            openBestGettingStartedRoute() {
                if (this.showLegacyExtraSuites && !this.isContentDisabled) {
                    this.$router.push("/content-project/setup")
                    return
                }

                this.$router.push("/ideas")
            },
            goToTutorialCenter() {
                try {
                    this.$router.push("/knowledge")
                } catch (error) {
                    this.openTutorial(this.videoUrls[1])
                }
            },
            openDemoBooking() {
                this.openlink("https://calendly.com/quaro-meeting/onboarding")
            },
            handleOnboardingAction(key) {
                this.markOnboardingStepCompleted(key)

                switch (key) {
                    case "research":
                        this.$router.push("/ideas")
                        break
                    case "content":
                        this.$router.push("/content-project/setup")
                        break
                    case "monitoring":
                        this.$router.push("/monitoring/setup")
                        break
                    case "ai":
                        this.$router.push("/ai-suite")
                        break
                    default:
                        break
                }
            },
            suiteDataExists(candidates = []) {
                const state = this.$store?.state || {}

                return candidates.some((key) => {
                    const value = state[key]

                    if (Array.isArray(value)) return value.length > 0
                    if (typeof value === "number") return value > 0
                    if (typeof value === "string") return value.length > 0

                    if (value && typeof value === "object") {
                        if (Array.isArray(value.items)) return value.items.length > 0
                        if (Array.isArray(value.data)) return value.data.length > 0
                        if (Array.isArray(value.results)) return value.results.length > 0
                        if (typeof value.count === "number") return value.count > 0
                        if (typeof value.total === "number") return value.total > 0
                        if (typeof value.length === "number") return value.length > 0
                    }

                    return false
                })
            }
        }
    }
</script>

<style>
    .btn-group-wrap {
        display: flex;
        flex-wrap: wrap;
        align-items: center;
        gap: 8px;
    }

    .btn-group-wrap .v-btn {
        margin: 0 !important;
    }

    .obislidesimg {
        border-radius: 10px;
        border: 2px solid grey;
        max-width: 100%;
        height: auto;
        display: block;
        margin-bottom: 10px;
    }

    .obislidesimg:hover {
        cursor: pointer;
    }

    .text-primary {
        color: var(--v-primary-base) !important;
    }

    .topboarder {
        border-top: 4px solid var(--v-primary-base) !important;
    }

    #searchsheet {
        margin-top: -30px;
        margin-left: 5px;
        width: 30px;
        height: 30px;
    }

    .transparent {
        background-color: transparent;
    }

    .theme--dark .homecardtitle {
        margin-bottom: 10px !important;
        color: white !important;
    }

    .homecardtitle {
        margin-bottom: 10px !important;
    }

    .video-container {
        position: relative;
        padding-bottom: 56.25%;
        height: 0;
        overflow: hidden;
    }

    .video-container iframe {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
    }

    .sr-only {
        position: absolute !important;
        width: 1px;
        height: 1px;
        padding: 0;
        margin: -1px;
        overflow: hidden;
        clip: rect(0 0 1px 1px);
        white-space: nowrap;
        border: 0;
    }

    .sr-only-focusable:focus {
        position: static !important;
        width: auto;
        height: auto;
        margin: 8px 0;
        padding: 6px 10px;
        background: #fff3cd;
        color: #000;
        border-radius: 6px;
        box-shadow: 0 0 0 3px rgba(255, 193, 7, 0.35);
    }

    .new-home-shell {
        padding: 8px 10px 20px 10px;
    }

    .new-home-heading {
        margin-bottom: 4px;
    }

    .new-home-title {
        font-family: "CalSans", sans-serif;
        font-size: 34px;
        line-height: 1.1;
        font-weight: 700;
        color: #15202b;
        margin-bottom: 6px;
    }

    .new-home-subtitle {
        font-size: 16px;
        line-height: 1.5;
        color: #5f6c77;
        margin-bottom: 0;
    }

    .onboarding-main-card,
    .onboarding-checklist-card,
    .onboarding-helper-card,
    .capabilities-wrapper {
        background: #fff !important;
        border-radius: 18px !important;
    }

    .onboarding-fill-card {
        width: 100%;
        height: 100%;
    }

    .onboarding-main-card {
        min-height: 320px;
    }

    .onboarding-main-card > .v-card__text {
        height: 100%;
    }

    .onboarding-main-layout {
        display: grid;
        grid-template-columns: 1.15fr 0.85fr;
        height: 100%;
        min-height: 320px;
        align-items: stretch;
    }

    .onboarding-main-content {
        padding: 34px 34px 34px 42px;
        display: flex;
        flex-direction: column;
        justify-content: center;
    }

    .onboarding-suite-switch {
        display: flex;
        flex-wrap: wrap;
        gap: 8px;
        margin-bottom: 16px;
    }

    .onboarding-suite-tab {
        min-width: 92px;
    }

    .onboarding-main-title {
        font-family: "CalSans", sans-serif;
        font-size: 32px;
        line-height: 1.1;
        font-weight: 700;
        color: #1b2430;
        margin-bottom: 14px;
    }

    .onboarding-main-text {
        font-size: 16px;
        line-height: 1.7;
        color: #5f6c77;
        max-width: 560px;
        margin-bottom: 0;
    }

    .onboarding-suite-disabled-note {
        font-size: 13px;
        line-height: 1.5;
        color: #8a949e;
    }

    .onboarding-main-btn {
        min-width: 290px;
        letter-spacing: 0.03em;
    }

    .onboarding-main-visual {
        display: flex;
        align-items: center;
        justify-content: flex-end;
        padding: 28px 24px 24px 0;
    }

    .onboarding-main-illustration {
        width: 100%;
        max-width: 330px;
        height: 240px;
        object-fit: contain;
        display: block;
    }

    .onboarding-main-illustration--research {
        max-width: 320px;
    }

    .onboarding-main-illustration--content {
        max-width: 300px;
    }

    .onboarding-main-illustration--monitoring {
        max-width: 320px;
    }

    .onboarding-main-illustration--ai {
        max-width: 340px;
    }

    .onboarding-suite-gfx {
        width: 100%;
        max-width: 430px;
    }

    .onboarding-suite-gfx svg {
        display: block;
        width: 100%;
        height: auto;
    }

    .swap-enter {
        animation: onboardingSwapIn 360ms ease both;
    }

    @keyframes onboardingSwapIn {
        from {
            opacity: 0;
            transform: translateY(8px);
        }
        to {
            opacity: 1;
            transform: none;
        }
    }

    .onboarding-main-image {
        width: 100%;
        max-width: 240px;
        height: auto;
    }

    .onboarding-checklist-title {
        font-family: "CalSans", sans-serif;
        font-size: 24px;
        line-height: 1.15;
        font-weight: 700;
        color: #1b2430;
    }

    .onboarding-checklist-progress {
        font-size: 13px;
        color: #6f7b85;
        white-space: nowrap;
    }

    .onboarding-checklist-subtitle {
        font-size: 14px;
        line-height: 1.5;
        color: #6f7b85;
    }

    .checklist-row {
        display: grid;
        grid-template-columns: 26px 1fr;
        gap: 12px;
        padding: 16px 0;
        border-top: 1px solid #edf1f2;
    }

    .checklist-row:first-of-type {
        border-top: 0;
        padding-top: 4px;
    }

    .checklist-content {
        min-width: 0;
    }

    .checklist-title-row {
        display: flex;
        align-items: flex-start;
        gap: 10px;
        justify-content: space-between;
    }

    .checklist-title {
        font-size: 18px;
        line-height: 1.3;
        font-weight: 700;
        color: #1b2430;
        margin-right: 12px;
    }

    .checklist-desc {
        font-size: 15px;
        line-height: 1.6;
        color: #6b7580;
        margin-top: 6px;
        max-width: 520px;
    }

    .checklist-action {
        flex-shrink: 0;
        min-width: 86px;
    }

    .status-pill {
        flex-shrink: 0;
        padding: 5px 12px;
        border-radius: 999px;
        font-size: 12px;
        font-weight: 700;
        line-height: 1;
    }

    .status-pill-done {
        background: rgba(0, 178, 123, 0.12);
        color: var(--v-primary-base);
    }

    .helper-card-top {
        display: flex;
        align-items: flex-start;
        gap: 16px;
    }

    .helper-icon-wrap {
        width: 62px;
        height: 62px;
        min-width: 62px;
        border-radius: 16px;
        background: rgba(0, 178, 123, 0.1);
        display: flex;
        align-items: center;
        justify-content: center;
    }

    .helper-card-title {
        font-family: "CalSans", sans-serif;
        font-size: 20px;
        line-height: 1.2;
        font-weight: 700;
        color: #1b2430;
        margin-bottom: 8px;
    }

    .helper-card-text {
        font-size: 15px;
        line-height: 1.6;
        color: #6b7580;
        margin-bottom: 0;
    }

    .capabilities-wrapper {
        border: 1px solid rgba(0, 178, 123, 0.26);
    }

    .capabilities-title {
        font-family: "CalSans", sans-serif;
        font-size: 26px;
        line-height: 1.15;
        font-weight: 700;
        color: #1b2430;
    }

    .capabilities-subtitle {
        font-size: 14px;
        line-height: 1.5;
        color: #6f7b85;
    }

    .suite-mini-card {
        border-radius: 14px !important;
        background: #fff;
        border-color: #e8ecef !important;
    }

    .suite-mini-label {
        font-size: 15px;
        font-weight: 700;
        margin-bottom: 10px;
    }

    .suite-mini-title {
        font-family: "CalSans", sans-serif;
        font-size: 22px;
        line-height: 1.15;
        font-weight: 700;
        margin-bottom: 10px;
        color: #111827;
    }

    .suite-mini-text {
        color: #6b7580;
        font-size: 14px;
        line-height: 1.55;
    }

    .h-100 {
        height: 100%;
    }

    @media (max-width: 1264px) {
        .onboarding-main-layout {
            grid-template-columns: 1fr;
        }

        .onboarding-main-content {
            padding: 30px 30px 10px 30px;
        }

        .onboarding-main-visual {
            padding: 0 30px 24px 30px;
            justify-content: center;
        }

        .onboarding-main-image {
            max-width: 180px;
        }
    }

    @media (max-width: 960px) {
        .new-home-title {
            font-size: 30px;
        }

        .onboarding-main-title {
            font-size: 28px;
        }

        .checklist-title-row {
            flex-direction: column;
            align-items: flex-start;
        }

        .onboarding-main-btn {
            min-width: 0;
            width: 100%;
        }

        .onboarding-main-illustration {
            max-width: 270px;
            height: 200px;
        }
    }

    @media (max-width: 600px) {
        .new-home-shell {
            padding-left: 0;
            padding-right: 0;
        }

        .onboarding-main-content {
            padding: 24px 22px 10px 22px;
        }

        .onboarding-main-visual {
            padding: 0 22px 22px 22px;
        }

        .new-home-title {
            font-size: 28px;
        }

        .onboarding-main-title {
            font-size: 26px;
        }

        .onboarding-main-illustration {
            max-width: 230px;
            height: 175px;
        }

        .helper-card-top {
            flex-direction: column;
        }
    }

    /* ===== Quaro Home v2 — integrated layout ===== */
    .qhome-v2 {
        --qh-primary: #009f89;
        --qh-primary-dark: #007a6b;
        --qh-primary-light: #33b9a7;
        --qh-primary-subtle: #e0f5f2;
        --qh-accent: #1cedb3;
        --qh-accent-subtle: #e8fdf7;
        --qh-warn: #e5a400;
        --qh-fg1: #0d2622;
        --qh-fg2: #2d5a54;
        --qh-fg3: #5a8c84;
        --qh-fg4: #8fbdb8;
        --qh-border: #d4ede9;
        --qh-border-light: #eef6f4;
        --qh-surface: #f2faf8;
        --qh-radius-lg: 12px;
        --qh-radius-xl: 16px;
        --qh-radius-2xl: 20px;
        --qh-radius-pill: 999px;
        --qh-shadow-sm: 0 1px 4px rgba(0, 159, 137, 0.08), 0 2px 8px rgba(0, 0, 0, 0.05);
        --qh-shadow-md: 0 2px 8px rgba(0, 159, 137, 0.08), 0 4px 16px rgba(0, 0, 0, 0.06);
        --qh-shadow-lg: 0 12px 36px rgba(10, 31, 28, 0.16), 0 2px 10px rgba(0, 159, 137, 0.1);
        max-width: 1440px;
        margin: 0 auto;
        padding: 24px 16px 64px;
        color: var(--qh-fg1);
        font-family: "Plus Jakarta Sans", "CalSans", system-ui, -apple-system, sans-serif;
    }
    .qhome-v2 *,
    .qhome-v2 *::before,
    .qhome-v2 *::after {
        box-sizing: border-box;
    }
    .qhome-v2 button {
        font-family: inherit;
    }

    .qh-greet h1 {
        font-size: 30px;
        font-weight: 700;
        letter-spacing: -0.02em;
        margin: 0 0 6px;
        font-family: "CalSans", "Plus Jakarta Sans", sans-serif;
    }
    .qh-greet p {
        margin: 0 0 28px;
        color: var(--qh-fg3);
        font-size: 16px;
    }

    /* Top row */
    .qh-toprow {
        display: grid;
        grid-template-columns: 1fr;
        gap: 24px;
        align-items: stretch;
        margin-bottom: 38px;
    }
    .qh-zone {
        display: flex;
        flex-direction: column;
    }

    /* Hero/deck (dark card) */
    .qh-hero {
        position: relative;
        border-radius: var(--qh-radius-2xl);
        overflow: hidden;
        background: linear-gradient(140deg, #0a1f1c 0%, #0d3330 100%);
        padding: 24px 28px 28px;
        box-shadow: var(--qh-shadow-lg);
        display: flex;
        flex-direction: column;
        flex: 1;
    }
    .qh-hero::before {
        content: "";
        position: absolute;
        width: 440px;
        height: 440px;
        right: -150px;
        top: -200px;
        border-radius: 50%;
        background: radial-gradient(circle, rgba(28, 237, 179, 0.3), transparent 62%);
        pointer-events: none;
    }
    .qh-deck-head {
        display: flex;
        gap: 8px;
        flex-wrap: wrap;
        margin-bottom: 22px;
        position: relative;
        z-index: 1;
    }
    .qh-ctab {
        display: inline-flex;
        align-items: center;
        gap: 7px;
        cursor: pointer;
        font-size: 13px;
        font-weight: 600;
        padding: 7px 15px;
        border-radius: var(--qh-radius-pill);
        border: 1px solid rgba(255, 255, 255, 0.18);
        background: rgba(255, 255, 255, 0.06);
        color: #cfe7e2;
        transition: all 140ms ease;
        white-space: nowrap;
    }
    .qh-ctab:hover {
        border-color: var(--qh-accent);
        color: #fff;
    }
    .qh-ctab.on {
        background: var(--qh-accent);
        border-color: var(--qh-accent);
        color: #06231d;
    }
    .qh-ctab.on .v-icon {
        color: #06231d !important;
    }

    .qh-deck-body {
        position: relative;
        z-index: 1;
        flex: 1;
        display: flex;
        min-height: 286px;
    }
    .qh-deck-2col {
        flex: 1;
        display: grid;
        grid-template-columns: 1fr 0.8fr;
        gap: 26px;
        align-items: center;
    }
    .qh-deck-left {
        min-width: 0;
    }
    .qh-eyebrow {
        display: inline-flex;
        align-items: center;
        gap: 8px;
        color: var(--qh-accent);
        font-size: 12px;
        font-weight: 700;
        letter-spacing: 0.1em;
        text-transform: uppercase;
        margin-bottom: 12px;
        white-space: nowrap;
    }
    .qh-deck-left h2 {
        color: #fff;
        font-size: 25px;
        font-weight: 700;
        letter-spacing: -0.02em;
        line-height: 1.18;
        margin: 0 0 9px;
        max-width: 18ch;
        font-family: "CalSans", "Plus Jakarta Sans", sans-serif;
        animation: qh-rise 0.3s ease;
    }
    .qh-sub {
        color: #9cc7bf;
        font-size: 14.5px;
        line-height: 1.5;
        margin: 0 0 18px;
        max-width: 46ch;
    }
    .qh-disabled-note {
        color: #cfe7e2;
        font-size: 12px;
        margin: 14px 0 0;
        opacity: 0.85;
    }

    .qh-field {
        display: flex;
        align-items: center;
        gap: 10px;
        background: #fff;
        border-radius: var(--qh-radius-xl);
        padding: 8px 8px 8px 18px;
        box-shadow: 0 10px 30px rgba(0, 0, 0, 0.25);
        margin-bottom: 14px;
    }
    .qh-field input {
        flex: 1;
        border: 0;
        outline: 0;
        font-family: inherit;
        font-size: 16px;
        color: var(--qh-fg1);
        background: transparent;
        padding: 11px 4px;
    }
    .qh-field input::placeholder {
        color: var(--qh-fg4);
    }
    .qh-send {
        flex: 0 0 auto;
        display: inline-flex;
        align-items: center;
        justify-content: center;
        gap: 8px;
        cursor: pointer;
        border: 0;
        border-radius: var(--qh-radius-pill);
        background: var(--qh-primary);
        color: #fff;
        font-weight: 700;
        transition: all 160ms ease;
        padding: 13px 22px;
        font-size: 14px;
    }
    .qh-send:hover {
        background: var(--qh-primary-dark);
    }
    .qh-send:disabled {
        background: #bcdcd6;
        cursor: not-allowed;
    }

    .qh-chips {
        display: flex;
        flex-wrap: wrap;
        gap: 9px;
    }
    .qh-chip {
        cursor: pointer;
        font-size: 13px;
        font-weight: 500;
        padding: 9px 14px;
        border-radius: var(--qh-radius-pill);
        display: inline-flex;
        align-items: center;
        gap: 7px;
        background: rgba(255, 255, 255, 0.07);
        border: 1px solid rgba(255, 255, 255, 0.16);
        color: #cfe7e2;
        transition: all 140ms ease;
    }
    .qh-chip:hover {
        background: rgba(28, 237, 179, 0.14);
        border-color: var(--qh-accent);
        color: #fff;
    }

    .qh-suite-btn {
        margin-top: 6px;
        cursor: pointer;
        border: 0;
        background: var(--qh-primary);
        color: #fff;
        font-size: 13px;
        font-weight: 700;
        letter-spacing: 0.03em;
        padding: 14px 28px;
        border-radius: var(--qh-radius-pill);
        box-shadow: 0 4px 14px rgba(0, 159, 137, 0.28);
        text-transform: uppercase;
        white-space: nowrap;
    }
    .qh-suite-btn:hover:not(:disabled) {
        background: var(--qh-primary-dark);
    }
    .qh-suite-btn:disabled {
        opacity: 0.55;
        cursor: not-allowed;
    }

    .qh-deck-right {
        display: flex;
        align-items: center;
        justify-content: center;
    }
    .qh-gpanel {
        background: #fff;
        border-radius: var(--qh-radius-xl);
        padding: 14px;
        box-shadow: 0 14px 36px rgba(0, 0, 0, 0.28);
        width: 100%;
    }
    .qh-gpanel .qh-gfx,
    .qh-gpanel .qh-gfx > * {
        width: 100%;
    }
    .qh-gpanel .qh-gfx svg {
        display: block;
        max-width: 100%;
        height: auto;
    }

    /* Checklist */
    .qh-check {
        background: #fff;
        border: 1px solid var(--qh-border);
        border-radius: var(--qh-radius-2xl);
        box-shadow: var(--qh-shadow-md);
        padding: 28px 30px;
        display: flex;
        flex-direction: column;
        border-top: 3px solid var(--qh-primary);
    }
    .qh-check .qh-h {
        display: flex;
        align-items: baseline;
        justify-content: space-between;
        gap: 10px;
    }
    .qh-check h3 {
        margin: 0;
        font-size: 19px;
        font-weight: 700;
    }
    .qh-check .qh-count {
        font-size: 13px;
        color: var(--qh-fg3);
        font-weight: 600;
    }
    .qh-check .qh-lead {
        margin: 6px 0 18px;
        font-size: 13.5px;
        color: var(--qh-fg3);
        line-height: 1.45;
    }
    .qh-check ul {
        list-style: none;
        margin: 0;
        padding: 0;
        display: flex;
        flex-direction: column;
    }
    .qh-check li {
        display: flex;
        gap: 12px;
        padding: 14px 0;
        border-top: 1px solid var(--qh-border-light);
    }
    .qh-check li:first-child {
        border-top: 0;
        padding-top: 0;
    }
    .qh-check .qh-ic {
        width: 24px;
        height: 24px;
        border-radius: 50%;
        background: var(--qh-primary);
        flex: 0 0 auto;
        display: flex;
        align-items: center;
        justify-content: center;
        margin-top: 1px;
    }
    .qh-check .qh-ic.pending {
        background: var(--qh-border);
    }
    .qh-check .qh-ti {
        display: flex;
        align-items: flex-start;

        gap: 9px;
    }
    .qh-check .qh-ti b {
        font-size: 14.5px;
        font-weight: 700;
        flex: 1;
    }
    .qh-check .qh-badge {
        flex: 0 0 auto;
        font-size: 10.5px;
        font-weight: 700;
        color: var(--qh-primary);
        background: var(--qh-accent-subtle);
        padding: 3px 9px;
        border-radius: var(--qh-radius-pill);
    }
    .qh-step-btn {
        flex: 0 0 auto;
        cursor: pointer;
        border: 0;
        background: var(--qh-primary);
        color: #fff;
        font-size: 11.5px;
        font-weight: 700;
        padding: 5px 12px;
        border-radius: var(--qh-radius-pill);
    }
    .qh-step-btn:hover {
        background: var(--qh-primary-dark);
    }
    .qh-check .qh-ds {
        margin: 3px 0 0;
        font-size: 12.5px;
        color: var(--qh-fg3);
        line-height: 1.4;
    }

    /* Help cards */
    .qh-help {
        display: grid;
        grid-template-columns: repeat(3, 1fr);
        gap: 24px;
        margin-bottom: 44px;
    }
    .qh-hcard {
        background: #fff;
        border: 1px solid var(--qh-border);
        border-radius: var(--qh-radius-2xl);
        box-shadow: var(--qh-shadow-sm);
        padding: 26px 28px;
        display: flex;
        flex-direction: column;
        transition: box-shadow 150ms ease;
    }
    .qh-hcard:hover {
        box-shadow: var(--qh-shadow-md);
    }
    .qh-hcard .qh-top {
        display: flex;
        align-items: flex-start;
        gap: 14px;
    }
    .qh-hcard .qh-ic {
        width: 46px;
        height: 46px;
        border-radius: 13px;
        background: var(--qh-accent-subtle);
        flex: 0 0 auto;
        display: flex;
        align-items: center;
        justify-content: center;
    }
    .qh-hcard h3 {
        margin: 0 0 6px;
        font-size: 17px;
        font-weight: 700;
    }
    .qh-hcard p {
        margin: 0;
        font-size: 13.5px;
        color: var(--qh-fg3);
        line-height: 1.5;
    }
    .qh-hcard .qh-act {
        margin-top: 18px;
        align-self: flex-start;
        cursor: pointer;
        border: 0;
        background: var(--qh-primary);
        color: #fff;
        font-size: 13px;
        font-weight: 700;
        padding: 11px 20px;
        border-radius: var(--qh-radius-pill);
        transition: background 150ms ease;
        white-space: nowrap;
    }
    .qh-hcard .qh-act:hover {
        background: var(--qh-primary-dark);
    }

    /* Explore + suite cards */
    .qh-explore-head {
        margin: 0 0 18px;
    }
    .qh-explore-head h2 {
        font-size: 21px;
        font-weight: 700;
        letter-spacing: -0.01em;
        margin: 0 0 5px;
        font-family: "CalSans", "Plus Jakarta Sans", sans-serif;
    }
    .qh-explore-head p {
        margin: 0;
        color: var(--qh-fg3);
        font-size: 13.5px;
    }
    .qh-suites {
        display: grid;
        grid-template-columns: repeat(4, 1fr);
        gap: 22px;
    }
    .qh-scard {
        background: #fff;
        border: 1px solid var(--qh-border);
        border-radius: var(--qh-radius-xl);
        box-shadow: var(--qh-shadow-sm);
        padding: 22px 22px 24px;
        display: flex;
        flex-direction: column;
        transition: all 150ms ease;
    }
    .qh-scard:hover {
        box-shadow: var(--qh-shadow-md);
        border-color: var(--qh-primary-light);
        transform: translateY(-2px);
    }
    .qh-scard .qh-lab {
        font-size: 12px;
        font-weight: 700;
        letter-spacing: 0.04em;
        color: var(--qh-primary);
        margin-bottom: 8px;
    }
    .qh-scard h3 {
        margin: 0 0 8px;
        font-size: 19px;
        font-weight: 700;
        letter-spacing: -0.01em;
    }
    .qh-scard p {
        margin: 0 0 18px;
        font-size: 13.5px;
        color: var(--qh-fg3);
        line-height: 1.5;
        flex: 1;
    }
    .qh-scard .qh-act {
        align-self: flex-start;
        cursor: pointer;
        border: 0;
        background: var(--qh-primary);
        color: #fff;
        font-size: 13px;
        font-weight: 700;
        padding: 10px 20px;
        border-radius: var(--qh-radius-pill);
        transition: background 150ms ease;
        white-space: nowrap;
    }
    .qh-scard .qh-act:hover {
        background: var(--qh-primary-dark);
    }

    @keyframes qh-rise {
        from {
            transform: translateY(8px);
            opacity: 0.6;
        }
        to {
            transform: translateY(0);
            opacity: 1;
        }
    }
    @keyframes qh-pulse {
        0%,
        100% {
            transform: scale(1);
            box-shadow: 0 0 0 0 rgba(0, 159, 137, 0.35);
        }
        50% {
            transform: scale(1.05);
            box-shadow: 0 0 0 14px rgba(0, 159, 137, 0);
        }
    }
    @keyframes qh-blink {
        0%,
        100% {
            opacity: 0.25;
            transform: translateY(0);
        }
        50% {
            opacity: 1;
            transform: translateY(-3px);
        }
    }

    @media (max-width: 1200px) {
        .qh-suites {
            grid-template-columns: repeat(2, 1fr);
        }
    }
    @media (max-width: 1080px) {
        .qh-help {
            grid-template-columns: 1fr 1fr;
        }
        .qh-deck-2col {
            grid-template-columns: 1fr;
        }
        .qh-deck-right {
            display: none;
        }
    }
    @media (max-width: 720px) {
        .qh-help {
            grid-template-columns: 1fr;
        }
        .qh-suites {
            grid-template-columns: 1fr;
        }
    }
</style>
